import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/OrderFrequencyReport/Filter'

export default createListViewComponent({
  entityName: entityNames.orderFrequencyReport,
  filterTemplateType: 'OrderFrequencyReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
